import React, {useState} from "react";
import {Button, Modal} from "react-bootstrap";
import {Edit2} from "react-feather";
import offersApi from "../../../../api/offertes";
import {Form as FormikForm, FormField, FormFieldDatePicker, SubmitButton} from "../../../../components/forms";
import moment from "moment";
import notyf from "../../../../utils/notyfApi";
import * as Yup from "yup";

function EditFinanceModal({exists, reload}) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleSubmit = async (values, {setSubmitting}) => {
        setSubmitting(false);
        const res = await offersApi.editOfferFinance(exists.sales_offer_id, {
            ...values,
            sales_offer_expected_assignment_date: moment(values.sales_offer_expected_assignment_date).toISOString().slice(0, -1),
            sales_offer_expected_completion_date: moment(values.sales_offer_expected_completion_date).toISOString().slice(0, -1),
            sales_offer_margin: parseFloat(values.sales_offer_margin),
            sales_offer_scoring_chance: parseFloat(values.sales_offer_scoring_chance),
            sales_offer_quotation_amount: parseFloat(values.sales_offer_quotation_amount),
        })
        if (!res.ok) return notyf.error("Error " + res.status)
        reload()
        handleClose()
    };

    return (
        <>
            <Edit2 onClick={handleShow} className={"float-end cursor-pointer"}/>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Financieel aanpassen
                    </Modal.Title>
                </Modal.Header>
                <FormikForm
                    initialValues={{
                        sales_offer_margin: exists ? parseFloat(exists.sales_offer_margin).toFixed(2) : 0,
                        sales_offer_scoring_chance: exists ? parseFloat(exists.sales_offer_scoring_chance).toFixed(2) : 0,
                        sales_offer_quotation_amount: exists ? parseFloat(exists.sales_offer_quotation_amount) : 0,
                        sales_offer_expected_assignment_date: exists?.sales_offer_expected_assignment_date || "",
                        sales_offer_expected_completion_date: exists?.sales_offer_expected_completion_date || "",
                    }}

                    validationSchema={Yup.object({
                        sales_offer_margin: Yup.number().required('Marge moet ingevuld worden'),
                        sales_offer_scoring_chance: Yup.number().required('Scoring kans moet ingevuld worden'),
                        sales_offer_quotation_amount: Yup.number().required('Offertebedrag moet ingevuld worden'),
                        sales_offer_expected_assignment_date: Yup.date().required("Verwachte opdrachtdatum moet ingevuld worden"),
                        sales_offer_expected_completion_date: Yup.date().required("Verwachte opleverdatum moet ingevuld worden"),
                    })}
                    onSubmit={handleSubmit}
                >
                    <Modal.Body>

                        <FormField name={"sales_offer_margin"}
                                   label={"Marge (%):*"}
                                   width={"100%"}
                                   className={"mb-3"}
                                   control={"input"}
                                   type={"number"}
                        />
                        <FormField name={"sales_offer_scoring_chance"}
                                   label={"Scoringskans (%):*"}
                                   width={"100%"}
                                   className={"mb-3"}
                                   type={"number"}
                        />
                        <FormField name={"sales_offer_quotation_amount"}
                                   label={"Offertebedrag (€):*"}
                                   width={"100%"}
                                   className={"mb-3"}
                                   type={"number"}
                        />
                        <FormFieldDatePicker name={"sales_offer_expected_assignment_date"}
                                             label={"Verwachte opdrachtdatum:*"}
                                             width={"100%"}
                                             className={"mb-3 form-control"}
                                             control={"input"}
                        />
                        <FormFieldDatePicker name={"sales_offer_expected_completion_date"}
                                             label={"Verwachte opleverdatum:*"}
                                             width={"100%"}
                                             className={"mb-3 form-control"}
                                             control={"input"}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Niet aanpassen
                        </Button>
                        <SubmitButton title={"Opslaan"} variant="primary"/>
                    </Modal.Footer>
                </FormikForm>
            </Modal>
        </>
    );
}

export default EditFinanceModal;
